
const notifyNavigationChange = () => {
  try {
    window.dispatchEvent(new Event('navigation'))
  } catch (error) {
    console.warn('Erro ao disparar evento de navegação:', error)
  }
}

export const goBack = (history, fallbackAction = null, fallbackPath = '/') => {
  // Verificar se existe histórico de navegação na sessão
  try {
    const navigationHistory = JSON.parse(sessionStorage.getItem('navigationHistory') || '[]')
    if (navigationHistory.length >= 2) {
      // Remover o caminho atual do histórico
      navigationHistory.pop()
      // Navegar para a página anterior no histórico
      const previousPath = navigationHistory[navigationHistory.length - 1]
      // Atualizar o histórico na sessionStorage sem o caminho atual
      sessionStorage.setItem('navigationHistory', JSON.stringify(navigationHistory))
      // Notificar sobre a mudança
      notifyNavigationChange()
      // Navegar para a página anterior
      history.push(previousPath)
      return
    }
  } catch (error) {
    console.warn('Erro ao acessar histórico de navegação:', error)
  }

  // Se não conseguiu usar o histórico da sessão e temos uma ação de fallback
  if (fallbackAction && typeof fallbackAction === 'function') {
    fallbackAction()
    return
  }

  // Se temos um referrer do mesmo domínio, usamos history.goBack()
  try {
    const referrer = document.referrer
    if (referrer && referrer.includes(window.location.hostname)) {
      history.goBack()
      return
    }
  } catch (error) {
    console.warn('Erro ao verificar referrer:', error)
  }

  // Se todas as tentativas anteriores falharem, navegar para o caminho padrão
  history.push(fallbackPath)
}
export const addToHistory = (path) => {
  try {
    let historyArr = JSON.parse(sessionStorage.getItem('navigationHistory') || '[]')

    // Verificar se a nova rota é diferente da última registrada
    const lastPath = historyArr.length > 0 ? historyArr[historyArr.length - 1] : null

    // Só adicionamos ao histórico se for uma rota diferente da última
    if (path !== lastPath) {
      // Verificar se o caminho já existe no histórico
      const existingIndex = historyArr.indexOf(path)

      // Se o caminho já existe no histórico, remover todas as entradas após ele
      // para evitar ciclos de navegação
      if (existingIndex !== -1) {
        historyArr = historyArr.slice(0, existingIndex + 1)
      } else {
        // Adicionar a nova rota ao histórico
        historyArr.push(path)
      }

      // Limitar o tamanho do histórico para evitar excesso de dados
      const limitedHistory = historyArr.slice(-20)

      // Armazenar na sessionStorage
      sessionStorage.setItem('navigationHistory', JSON.stringify(limitedHistory))

      // Notificar sobre a mudança
      notifyNavigationChange()
    }
  } catch (error) {
    console.warn('Erro ao adicionar ao histórico de navegação:', error)
  }
}

export const getNavigationHistory = () => {
  try {
    return JSON.parse(sessionStorage.getItem('navigationHistory') || '[]')
  } catch (error) {
    console.warn('Erro ao obter histórico de navegação:', error)
    return []
  }
}

export const clearNavigationHistory = () => {
  try {
    sessionStorage.removeItem('navigationHistory')
    // Notificar sobre a mudança
    notifyNavigationChange()
  } catch (error) {
    console.warn('Erro ao limpar histórico de navegação:', error)
  }
}
